export const white = '#fff'
export const black = '#000'

export const brightred = '#D0021B'
export const red = '#8F1004'
export const blue = '#A2B5BD'
export const darkblue = '#617F8B'
export const gold = '#ABA089'

/* light to dark */
export const whitegray = '#fafafa'
export const lightergray = '#efefef'
export const lightgray = '#dedede'
export const gray = '#b8b8b8'
export const mediumgray = '#9b9b9b'
export const darkgray = '#2a2a2a'
export const almostblack = '#232327'

export const bordergray = '#dedede' // = lightgray
export const inputgray = '#9b9b9b' // = mediumgray
export const body = '#fcfcfc'



// WEBPACK FOOTER //
// ./src/styles/colors.js